/**
 * @generated SignedSource<<4f6e9a81122087721544f40bbf19638b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ChatThreadEditDialog_Recipient$data = {
  readonly id?: string;
  readonly name?: string | null | undefined;
  readonly " $fragmentType": "ChatThreadEditDialog_Recipient";
};
export type ChatThreadEditDialog_Recipient$key = {
  readonly " $data"?: ChatThreadEditDialog_Recipient$data;
  readonly " $fragmentSpreads": FragmentRefs<"ChatThreadEditDialog_Recipient">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ChatThreadEditDialog_Recipient",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": (v0/*: any*/),
      "type": "User",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v0/*: any*/),
      "type": "ChatBot",
      "abstractKey": null
    }
  ],
  "type": "Recipient",
  "abstractKey": "__isRecipient"
};
})();

(node as any).hash = "115d881c3c94d6a2e50d0c4006bf0a0e";

export default node;
